import { useQuery } from 'react-query';
import { getDayOfWeek } from '@/utils/graphqlApis';
import { parseDayOfWeek } from '@/parser/common/index';
import { useRecoilValue } from 'recoil';
import { authState } from '@/recoil/auth';

const useDayOfWeekQuery = (date: string) => {
  const { token } = useRecoilValue(authState);

  const result = useQuery(['dayOfWeek'], () => getDayOfWeek(
    date
  ), {
    select: parseDayOfWeek,
    enabled: !!token,
  });

  return result.data;
};

export default useDayOfWeekQuery;